/**
 * @file Automatically generated by barrelsby.
 */

export * from './ShopReviewContent';
